<template>
  <a-form :form="form" class="single-import-box">
    <a-form-item label="姓名" v-bind="formItemLayout">
      <a-input
        placeholder=" 请输入"
        v-decorator="['staffName', {rules: [{ required: true,message: '请输入姓名'}], validateTrigger: 'change,blur'}]"/>
    </a-form-item>
    <a-form-item label="手机号" v-bind="formItemLayout">
      <a-input
        placeholder=" 请输入"
        v-decorator="['staffMobile', {rules: [{ required: true,validator: handlePhoneInput }], validateTrigger: 'blur'}]"
      />
    </a-form-item>
    <a-form-item label="身份证号" v-bind="formItemLayout">
      <a-input
        placeholder=" 请输入"
        v-decorator="['staffCardNo',  {rules: [{ required: false,type: 'string', message: '请输入身份证号' }], validateTrigger: 'blur'} ]"
      />
    </a-form-item>
    <a-form-item label=" 身份证人像面" v-bind="formItemLayout">
      <div class="upload-box">
        <a-upload
          :action="uploadFileUrl"
          :multiple="false"
          :showUploadList="false"
          listType="picture-card"
          @change="fileInfo=>handleChange(fileInfo,1)"
          :before-upload="handleBeforeUploadImage"
        >
          <img v-if="staffCardPositive" :src="staffCardPositive" alt="avatar" class="selected-image"/>
          <div v-else>
            <a-icon :type="loadingCardPositive? 'loading' : 'plus'"/>
          </div>
        </a-upload>
        <img src="https://imgb.woyoubooking.com/common/person_card.jpg"
             :class="[staffCardPositive?'image-sample':'image-sample-1']">
      </div>
    </a-form-item>
    <a-form-item label=" 身份证国徽面" v-bind="formItemLayout">
      <div class="upload-box">
        <a-upload
          :action="uploadFileUrl"
          :multiple="false"
          :showUploadList="false"
          listType="picture-card"
          @change="fileInfo=>handleChange(fileInfo,2)"
          :before-upload="handleBeforeUploadImage"
        >
          <img v-if="staffCardRear" :src="staffCardRear" alt="avatar" class="selected-image"/>
          <div v-else>
            <a-icon :type="loadingCardRear? 'loading' : 'plus'"/>
          </div>
        </a-upload>
        <img src="https://imgb.woyoubooking.com/common/nation_card.jpg"
             :class="[staffCardRear?'image-sample':'image-sample-1']">
      </div>
    </a-form-item>
    <a-form-item label=" 店铺logo" v-bind="formItemLayout">
      <div class="upload-box">
        <a-upload
          :action="uploadFileUrl"
          :multiple="false"
          listType="picture-card"
          :showUploadList="false"
          v-decorator="['staffShopLogo',{rules:[{required:true, message: '请上传店铺logo'}]}]"
          @change="fileInfo=>handleChange(fileInfo,3)"
          :before-upload="handleBeforeUploadImage"
        >
          <img v-if="staffShopLogo" :src="staffShopLogo" class="selected-image"/>
          <div v-else>
            <a-icon :type="loadingShopLogo? 'loading' : 'plus'"/>
          </div>
        </a-upload>
      </div>
    </a-form-item>
    <a-form-item label="店铺名称" v-bind="formItemLayout">
      <a-input
        v-decorator="['staffShopName',  {rules: [{ required: true, message: '请输入店铺名称' }], validateTrigger: 'blur'} ]"
        placeholder="请输入"/>
    </a-form-item>
    <a-form-item label="客服名称" v-bind="formItemLayout">
      <a-input
        v-decorator="['staffServiceName',  {rules: [{ required: false, message: '请输入客服名称' }], validateTrigger: 'blur'} ]"
        placeholder="请输入"/>
    </a-form-item>
    <a-form-item label="客服电话" v-bind="formItemLayout">
      <a-input
        v-decorator="['staffServicePhone',  {rules: [{ required: false, message: '请输入客服电话' }], validateTrigger: 'blur'} ]"
        placeholder="请输入"
      />
    </a-form-item>
    <a-form-item v-bind="formItemLayoutBtn">
      <a-button type="primary" @click="saveEvent" :loading="saveLoading">保存</a-button>
      <a-button @click="backEvent" style="margin-left: 10px">返回</a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import formMixin from '../../../utils/mixins/formMixins'

export default {
  name: 'SingleImportComponent',
  mixins: [formMixin],
  data() {
    return {
      staffShopLogo: '',
      staffCardRear: '',
      staffCardPositive: '',
      loadingCardRear: false,
      loadingCardPositive: false,
      loadingShopLogo: false
    }
  },
  mounted() {
  },
  activated() {
    this.resetForm()
    this.staffShopLogo = ''
  },
  methods: {
    //文件变更监听
    handleChange(fileInfo, index) {
      if (fileInfo.file.status === 'uploading') {
        if (index === 1) {
          this.loadingCardPositive = true
        } else if (index === 2) {
          this.loadingCardRear = true
        } else if (index === 3) {
          this.loadingShopLogo = true
        }
      } else if (fileInfo.file.status === 'done') {
        // Get this url from response in real world.
        const url = this.getLatestUrlFromFileList(fileInfo.fileList)
        if (index === 1) {
          this.staffCardPositive = url
          this.loadingCardPositive = false
        } else if (index === 2) {
          this.staffCardRear = url
          this.loadingCardRear = false
        } else if (index === 3) {
          this.staffShopLogo = url
          this.loadingShopLogo = false
        }
      }
    },
    saveEvent() {
      this.validateFormParams().then(values => {
        this.getLogUtils().logWithTag('params====', values)
        this.createRequest(values)
      }).catch(reason => this.getLogUtils().errorWithTag('params====', reason))
    },
    createRequest(values) {
      const params = {
        ...values,
        staffCardPositive: this.staffCardPositive,
        staffCardRear: this.staffCardRear,
        staffShopLogo: this.staffShopLogo
      }
      this.saveLoading = true
      this.getHttpServices().getUserService().post('staff/v2/saveStaff', params)
        .then(res => {
          this.$message.success('添加成功')
          setTimeout(() => this.backEvent(), 500)
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.saveLoading = false)
    }
  }

}
</script>
<style lang="less" scoped>
.single-import-box {
  .upload-box {
    margin-top: 14px;
    height: 104px;
    position: relative;
  }

  .selected-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 180px;
    height: 104px;
  }

  .image-sample {
    position: absolute;
    top: 0;
    left: 200px;
    height: 104px;
  }

  .image-sample-1 {
    position: absolute;
    top: 0;
    left: 112px;
    height: 104px;
  }

  input {
    max-width: 400px;
  }

  .single-import-box > .ant-upload {
    width: 180px;
    height: 104px;
  }

  .picture-card .ant-upload-list-item {
    padding: 0;
  }
}

</style>